module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShownVisualizationPanel),
      expression: "isShownVisualizationPanel"
    }],
    staticClass: "layer-mask",
    on: {
      "click": _vm.hideVisualizationPanel
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lift"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShownVisualizationPanel),
      expression: "isShownVisualizationPanel"
    }],
    staticClass: "layer-contents"
  }, [_c('img', {
    staticClass: "layer-contents-close-button",
    attrs: {
      "src": require("@/assets/images/close_button.svg")
    },
    on: {
      "click": _vm.hideVisualizationPanel
    }
  }), _vm._v(" "), _c('v-ons-row', {
    staticClass: "layers",
    attrs: {
      "vertical-align": "center"
    }
  }, _vm._l((_vm.visualizationLayers), function(visualizationLayer) {
    return _c('v-ons-col', {
      key: visualizationLayer.value,
      class: ['layer', {
        current: _vm.isCurrent(visualizationLayer.value)
      }],
      on: {
        "click": function($event) {
          return _vm.switchVisualizationLayerType(visualizationLayer.value)
        }
      }
    }, [_c('div', {
      staticClass: "layer-title"
    }, [_vm._v(_vm._s(visualizationLayer.name))]), _vm._v(" "), _c('div', {
      staticClass: "layer-panel"
    }, [_c('img', {
      attrs: {
        "src": visualizationLayer.image
      }
    })])])
  }), 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95de988","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/panel.vue
// module id = 782
// module chunks = 0